import { ActionQueueType } from '@gv/triage-components';

import { useAppSelector } from 'store';
import { selectCurrentTask } from 'store/api/action-queue/selectors';

export const useCommunicationStatus = () => {
  const currentTask = useAppSelector(selectCurrentTask);
  const { isOnCall, isOnVideoCall } = useAppSelector((state) => state.call);
  const hasActiveTask =
    !!currentTask &&
    (currentTask.type === ActionQueueType.Chat ||
      currentTask.type === ActionQueueType.SMS ||
      currentTask.type === ActionQueueType.Video);

  const isOnVoiceCall = isOnCall;
  const isOnVideoCallSession = isOnVideoCall;
  const isInCommunication =
    hasActiveTask || isOnVoiceCall || isOnVideoCallSession;

  return {
    currentTask,
    hasActiveTask,
    isOnVoiceCall,
    isInCommunication,
    isOnVideoCallSession,
  };
};
